<template>
  <div id="app" ref="scrollContainer">
    <router-view></router-view>
  </div>
</template>

<script setup>
import { ref } from "vue";
const scrollContainer = ref(null);
import emitter from "@/utils/emitter";

emitter.on("update", (val) => {
  scrollContainer.value.scrollTop = 0;
});

// 定义在线 JSON 文件的 URL
const jsonUrl = "https://daojuji.oss-cn-hangzhou.aliyuncs.com/zyjt/config.json";

// 创建 XMLHttpRequest 对象
const xhr = new XMLHttpRequest();

// 打开请求
xhr.open("GET", jsonUrl, true);

// 监听请求状态变化
xhr.onreadystatechange = function () {
  if (xhr.readyState === 4) {
    if (xhr.status === 200) {
      try {
        // 解析响应数据为 JSON 格式
        const data = JSON.parse(xhr.responseText);
        if (data.zy_website_is_close) {
          const domApp = document.getElementById("app");
          const dom = document.createElement("div");
          dom.style.position = "fixed";
          dom.style.top = "0";
          dom.style.left = "0";
          dom.style.height = "100%";
          dom.style.width = "100%";
          dom.style.overflow = "hidden";
          dom.style.zIndex = 100;
          dom.style.background = "rgba(0,0,0,0.1)";
          dom.innerHTML = "";
          dom.style.display = "flex";
          dom.style.alignItems = "center";
          dom.style.justifyContent = "center";
          dom.style.color = "#fff";
          dom.style.fontSize = "100px";
          dom.style.fontWeight = "bold";
          domApp.appendChild(dom);
        }
      } catch (error) {
        // 处理 JSON 解析错误
        console.error("JSON parsing error:", error);
      }
    } else {
      // 处理请求失败的情况
      console.error("Request failed with status:", xhr.status);
    }
  }
};

// 发送请求
xhr.send();
</script>

<style></style>
